import { createGlobalStyle } from 'styled-components';
import media from './config/mediaQueries';

const GlobalStyle = createGlobalStyle`

  html {
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
    font-size: 62.5%;
  }

  body {
    text-rendering: optimizeSpeed;
    font-family: Poppins, sans-serif;
    background: ${({ theme }) => theme.color.black};
    color: ${({ theme }) => theme.color.white};
    margin: 0;
    padding: 0;
    font-size: 1.3rem;
  }

  .app {
    ${media.mobile`
      padding: 64px 0 67px;
    `}
    ${media.desktop`
      padding-top: 81px;
    `}
  }

  /* https://piccalil.li/blog/a-modern-css-reset/ */

  /* Box sizing rules */
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  /* Remove default margin */
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  figure,
  blockquote,
  dl,
  dd {
    margin: 0;
    line-height: 1.5;
  }

  /* Remove list styles on ul, ol elements with a list role, which suggests default styling will be removed */
  ul[role='list'],
  ol[role='list'] {
    list-style: none;
  }
  ul,
  ol {
    margin: 0;
    padding: 0;
  }

  li{
    list-style-type: none;
  }

  /* Set core root defaults */
  html:focus-within {
    scroll-behavior: smooth;
  }

  /* Make images easier to work with */
  img,
  picture {
    max-width: 100%;
    display: block;
  }

  /* Inherit fonts for inputs and buttons */
  input,
  button,
  textarea,
  select {
    font: inherit;
    border: 0;
    outline: none;
  }

  button,
  a {
    background-color: transparent;
    text-align: left;
    line-height: 1.5;
    padding: 0;
    border: 0;
    text-decoration: none;
    cursor: pointer;
    color: ${({ theme }) => theme.color.white};
  }

  /* A elements that don't have a class get default styles */
  a:not([class]) {
    text-decoration-skip-ink: auto;
  }

  [hidden] {
    display: none;
  }

  .sr-only {
    border: 0;
    clip: rect(1px, 1px, 1px, 1px);
    -webkit-clip-path: inset(50%);
    clip-path: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
    white-space: nowrap;
  }

  svg {
    pointer-events: none;
  }
`;

export default GlobalStyle;
